export class ClassificationResultValues {
  public static reason = [
    'Award Claim',
    'Absolute Claim',
    'Brand Social Cause',
    'Category Claim',
    'Comparative / Superiority Claim',
    'Data Based Claim',
    'Endorsement - Institute / Celebrity / Partnership / Professional / Others',
    'Environment / Greenwashing / Sustainable',
    'Free From Claim',
    'Free Items',
    'Hygiene Claim',
    'Impact of external Regulation',
    'Ingredient Claim',
    'Insight / Fact',
    'Marketing Text',
    'Medical / Borderline Claim',
    'Natural Claim',
    'New / Improved - Product / Pack / Formulation',
    'Not a claim - Marketing Campaign / Communication / Promotional Offers / Others',
    'Not a claim - Price / Address / Company / Product / Usage / Store / Website / Terms',
    'Not allowed in Unilever',
    'Numerical Claim',
    'Over Promise / Misleading / Ambiguous Claims',
    'Performance Claim',
    'Political / Cultural Sensitivity',
    'Potentially Provocative Claim',
    'Sensitive Skin / Safe for Skin',
    'Top Parity Claim',
    'Trade Mark',
    'Unique RTB',
    'Other',
  ];
}
